import createIcon from '../../createIcon';

/**
 * @component @name TakeoutDining
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMjYgMTFIMTguNzRMMTguMDcgMjBINS45M0w1LjI2IDExWk05LjAyIDRIMTQuOTdMMTkgNy4zOEwyMC41OSA1Ljc5TDIyIDcuMjFMMTkuMjEgMTBINC43OUwyIDcuMjFMMy40MSA1LjhMNSA3LjM4TDkuMDIgNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TakeoutDining = createIcon('TakeoutDining', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.26 11H18.74L18.07 20H5.93L5.26 11ZM9.02 4H14.97L19 7.38L20.59 5.79L22 7.21L19.21 10H4.79L2 7.21L3.41 5.8L5 7.38L9.02 4Z',
      key: '12oswe',
    },
  ],
]);

export default TakeoutDining;
